import { ILibraryTopology } from '../registry.types';
import { getComponentsLibrariesFromURL } from './getComponentsLibrariesFromURL';

export interface IServiceTopology {
  scriptsLocationMap: Record<string, string>;
  [key: string]: undefined | boolean | string | Record<string, string>;
}

const DESIGN_SYSTEMS_NAMESPACE = 'dsgnsys';

function getArtifactID({
  artifactId,
  namespace,
}: {
  artifactId: string;
  namespace: string;
}) {
  /**
   * There are two libs are published with the same artifact id, which affects on runtime:
   * https://github.com/wix-private/editor-elements/blob/remove-tb-from-ee/packages/editor-elements-registry/src/toolbox/registryAPI.ts#L153
   *
   * This function allows to override the artifact ID
   */
  if (namespace === DESIGN_SYSTEMS_NAMESPACE) {
    return `${artifactId}-design-systems`;
  }

  return artifactId;
}

/**
 * This is a temp source of truth until a better alternative is supplied via DevCenter or something similar
 */
export const whitelist = [
  {
    artifactId: 'editor-elements',
    namespace: 'wixui',
  },
  {
    artifactId: 'editor-elements',
    namespace: 'dsgnsys',
  },
];

export { getComponentsLibrariesFromURL };
/**
 * Will return list of components libraries with actual urls to each one of them.
 * In case when "serviceTopology" is not provided a whitelist of libraries
 * without urls will be returned
 */
export const getComponentsLibraries = (
  serviceTopology?: IServiceTopology,
  url?: string,
  prefix?: string,
) => {
  const urlLibraries: Array<ILibraryTopology> = [];

  if (url) {
    urlLibraries.push(...getComponentsLibrariesFromURL(url, prefix));
  }

  if (!serviceTopology) {
    return [...urlLibraries];
  }

  const topologyLibraries = whitelist.reduce((acc, lib) => {
    const { artifactId } = lib;

    const libraryEntryInTopology =
      serviceTopology[artifactId] ||
      serviceTopology.scriptsLocationMap[artifactId];

    if (typeof libraryEntryInTopology === 'string') {
      acc.push({
        ...lib,
        artifactId: getArtifactID({ artifactId, namespace: lib.namespace }),
        url: libraryEntryInTopology,
      });
    }

    return acc;
  }, [] as Array<ILibraryTopology>);

  return [...topologyLibraries, ...urlLibraries];
};
